import { jwtDecode } from 'jwt-decode';

export const tokenExpirationHandler = {
  handleExpiration: function (expiryToken, navigate) {
    try {
      if (expiryToken) {
        const decoded = jwtDecode(expiryToken);

        if (!decoded) {
          navigate('/token-expired', { state: { error: 'Token not provided.' } });
          return;
        }

        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds

        if (decoded.exp && decoded.exp < currentTime) {
          navigate('/token-expired', { state: { error: 'Token has expired.' } });
        }
      }
    } catch (err) {
      navigate('/token-expired', { state: { error: err.message || 'Invalid token.' } });
    }
  },
};
